// /src/i18n/lang.js
export const SUPPORTED_LANGS = ['uk', 'en', 'it', 'fr'];
export const DEFAULT_LANG = 'uk';

// Извлекает язык из пути (/uk/..., /en/..., /it/...)
export function getLangFromPath(pathname) {
  const seg = (String(pathname || '').split('/').filter(Boolean)[0] || '').toLowerCase();
  return SUPPORTED_LANGS.includes(seg) ? seg : DEFAULT_LANG;
}

// Нормализует путь без языка: "/service/geo" -> "/service/geo"
export function stripLangPrefix(pathname) {
  const parts = String(pathname || '').split('/').filter(Boolean);
  if (parts.length && SUPPORTED_LANGS.includes(parts[0].toLowerCase())) {
    parts.shift();
  }
  return '/' + parts.join('/');
}

// Собирает путь с нужным языком, сохраняя query/hash (если переданы отдельно)
export function buildPathWithLang(lang, pathname, search = '', hash = '') {
  const tail = stripLangPrefix(pathname).replace(/^\/+/, ''); // "service/geo" или ""
  const path = `/${lang}/${tail}`;
  return `${path}${search || ''}${hash || ''}`.replace(/\/{2,}/g, '/');
}
